import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import ListaMunicipioService from "./listaMunicipioService"
import FormList from 'base/FormList'

export default function ListaMunicipioList() {

    const [service] = useState(() => new ListaMunicipioService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_limu',
        dsName: 'descricao_limu',
        mainField: { name: 'descricao_limu', label: 'Descrição' },
        advFields: [
            { name: 'codigo_limu', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_limu', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_limu" sortable header="Código"></Column>
            <Column field="descricao_limu" sortable header="Descrição"></Column>
        </FormList >
    )
}
